import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=49526a3c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49526a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49526a3c')) {
      api.createRecord('49526a3c', component.options)
    } else {
      api.reload('49526a3c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=49526a3c&scoped=true&", function () {
      api.rerender('49526a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xGD5lfQhFdZh/JS/comp/Accordion.vue"
export default component.exports